import { Fragment, ReactElement, useMemo } from 'react';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import { getBaseUrl } from '../get-base-url';
import { useParams } from 'react-router-dom';
import DetailNotificationsShared from '../../research-notifications/detail';

interface DetailAnscNotificationsSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const DetailAnscNotificationsShared = ({
  scope,
  items,
}: DetailAnscNotificationsSharedProps): ReactElement => {
  const params = useParams();
  const idCat = params.idCat || undefined;

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope, idCat]);

  return (
    <Fragment>
      <DetailNotificationsShared items={items} baseUrl={baseUrl} />
    </Fragment>
  );
};

DetailAnscNotificationsShared.displayName = 'Detail Notifications Ansc component';

export default DetailAnscNotificationsShared;
